/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaCategoriesResponseAllOf,
    MediaCategoriesResponseAllOfFromJSON,
    MediaCategoriesResponseAllOfFromJSONTyped,
    MediaCategoriesResponseAllOfToJSON,
} from './MediaCategoriesResponseAllOf';
import {
    MediaCategoriesResponseAllOfData,
    MediaCategoriesResponseAllOfDataFromJSON,
    MediaCategoriesResponseAllOfDataFromJSONTyped,
    MediaCategoriesResponseAllOfDataToJSON,
} from './MediaCategoriesResponseAllOfData';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';

/**
 * 全てのカテゴリを取得した時のレスポンス
 * @export
 * @interface MediaCategoriesResponse
 */
export interface MediaCategoriesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof MediaCategoriesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof MediaCategoriesResponse
     */
    message: string;
    /**
     * 
     * @type {MediaCategoriesResponseAllOfData}
     * @memberof MediaCategoriesResponse
     */
    data: MediaCategoriesResponseAllOfData;
}

export function MediaCategoriesResponseFromJSON(json: any): MediaCategoriesResponse {
    return MediaCategoriesResponseFromJSONTyped(json, false);
}

export function MediaCategoriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaCategoriesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': MediaCategoriesResponseAllOfDataFromJSON(json['data']),
    };
}

export function MediaCategoriesResponseToJSON(value?: MediaCategoriesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': MediaCategoriesResponseAllOfDataToJSON(value.data),
    };
}

